import { CloseModalSVG } from "../SVGs/CommonSVG"

const ModalHeader = (props) => {
    const { setModal, headerTitle } = props
    return (
        <div className='px-6 py-4 rounded-t-modal border-b border-neutral-100'>
            <h5 className='lg:text-xl sm:text-lg text-base font-semibold break-words text-neutral-900 tracking-tight'>{headerTitle}</h5>
            <button
                className="absolute -top-3 -right-3 rounded-full bg-white shadow-float hover:shadow-pop hover:scale-105 active:scale-95 transition-all duration-150"
                onClick={() => setModal(null)}
                aria-label="Close modal"
            >
                <CloseModalSVG />
            </button>
        </div>
    )
}

export default ModalHeader
